import { SortingType } from 'constants/index';

import { AssessmentReportField } from './types';

export const DEFAULT_SORT = {
    field: AssessmentReportField.ASSESSMENT_REPORT_DATE,
    type: SortingType.DESC,
};
